<script>
    import {querystring, push} from 'svelte-spa-router'
    import {toUrlEncoded} from './util/urlUtil'
    import qs from 'qs'

    let queryStringObject = qs.parse($querystring);
    let errors = false,
            codeMissing = false,
            jsonError = false,
            codeAlreadyVerifiedError = false,
            backendError = false;

    if (queryStringObject && queryStringObject.code) {
        fetch("https://safe-at-work-api.ritenoar.be/saw-confirm", {
            method: "POST",
            body: toUrlEncoded({
                code: queryStringObject.code
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }).then(r => r.json())
                .then(data => {
                    if (data.error) {
                        errors = true;
                        if (data.error === "Order already verified") {
                            codeAlreadyVerifiedError = true;
                        } else {
                            backendError = true;
                        }
                    } else {
                        push("/confirmed");
                    }
                })
                .catch((error) => {
                    errors = true;
                    jsonError = true;
                    console.error('Error:', error);
                });
    } else {
        errors = true;
        codeMissing = true;
    }
</script>

<style>

    #loader-wrapper {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }

    #loader {
        display: block;
        position: relative;
        left: 30%;
        top: 40%;
        width: 50px;
        height: 50px;
        margin: -85px 0 0 -85px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #3498db;

        -webkit-animation: spin 2s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 2s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    }

    #loader:before {
        content: "";
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #e74c3c;

        -webkit-animation: spin 3s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 3s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    }

    #loader:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #f9c922;

        -webkit-animation: spin 1.5s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 1.5s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    }

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg); /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(0deg); /* IE 9 */
            transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
        }
        100% {
            -webkit-transform: rotate(360deg); /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(360deg); /* IE 9 */
            transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
        }
    }

    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg); /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(0deg); /* IE 9 */
            transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
        }
        100% {
            -webkit-transform: rotate(360deg); /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(360deg); /* IE 9 */
            transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
        }
    }

</style>

{#if codeMissing}
    <div class="notification is-danger is-light">
        Er ontbreekt een code.
    </div>
{/if}

{#if codeAlreadyVerifiedError}
    <div class="notification is-danger is-light">
        De bestelling voor deze code is reeds bevestigd.
    </div>
{/if}

{#if backendError}
    <div class="notification is-danger is-light">
        Er heeft zich een onverwachte fout voorgedaan.
    </div>
{/if}

{#if jsonError}
    <div class="notification is-danger is-light">
        Er is iets misgegaan met het verwerken van het resultaat van deze bevestiging. Vermoedelijk is uw bestelling
        wel goed doorgekomen. Je kan ons voor meer informatie contacteren op
        <a href="mailto:safe-at-work@smidt-imex.com">safe-at-work@smidt-imex.com</a>.
    </div>
{/if}

{#if !errors}
    <section class="section">
        <div>
            <p>Uw bestelling wordt bevestigd... </p>
        </div>
    </section>

    <div id="loader-wrapper">
        <div id="loader"></div>

        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
    </div>
{/if}